export default __webpack_public_path__ + "static/linkBg1_shadow-a266e0be6729fd1dd369bd6179b6668e.png";